import { CTAPopup } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import React from "react";

export const CRMInvalidUserPopup: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
}> = ({ isOpen, onRequestClose }) => {
  const { t } = useTranslations();

  return (
    <CTAPopup
      isOpen={isOpen}
      icon="⚠️"
      title={t(
        {
          id: "client-support-page.message-cant-be-sent",
          defaultMessage: "Oops!{br}Message cant be sent",
        },
        { br: <br /> }
      )}
      content={
        <ul className="m-0 space-y-2 pl-5">
          <li>
            {t({
              id: "client-support-page.conversation-started-in-another-account",
              defaultMessage:
                "This conversation was started in your another account that is now disconnected",
            })}
          </li>
          <li>
            {t({
              id: "client-support-page.saved-chats-history=across-all-accounts",
              defaultMessage:
                "We save the history of chats across all accounts from one Media, but to reply in such chat, you need to be connected to initial Account from where this chat was triggered",
            })}
          </li>
        </ul>
      }
      buttons={[
        {
          label: t({
            id: "common.okay",
            defaultMessage: "Okay",
          }),
          variant: "danger",
          onClick: onRequestClose,
        },
      ]}
      onClose={onRequestClose}
    />
  );
};
